import React, { ReactElement } from "react";
import { t } from "../../translations/translation.service";
import { originalOpportunities } from "../../model/opportunity.model";
import { withRouter, RouteComponentProps } from "react-router-dom";
import ShortlistService from "../../services/shortlist.service";
import Board from "../../components/shortlistLink/kanban/board/Board";
import Loading from "../../components/loading";
import style from "./index.module.scss";
import Header from "../../components/shortlistLink/head";
import Footer from "../../components/shortlistLink/footer";
import EnterLogo from "../../images/logo-elumini.png"
import { Dispatch, AnyAction, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  clickUpdateShortlistStatusIsReproved,
  clickUpdateShortlistStatusIsSelected
} from '../../actions';

type Action = {
  at: string;
  by: string;
  deviceType: string;
  ip: string;
  userAgent: string;
  type: string;
}

type Token = {
  token: string;
  opportunityId: string;
  createdAt: string;
  createdBy: string;
  expireAt: string;
  action: Array<Action>;
  status: string;
}

type Candidate = {
  attachmentUrl: Array<string>;
  isReproved: boolean;
  isSelected: boolean;
  key: number;
  name: string;
  status: {
    current: number;
    history: Array<{
      status: number;
      date: string;
    }>;
  }
}

type OpportunityData = {
  idOpportunity: string;
  titulo: string;
  _id: string;
}

interface ShortlistKanbanProps {
  _id: string;
  token: Token;
  opportunityId: string;
  createdAt: string;
  createdBy: string;
  candidates: Array<Candidate>;
}


class LinkShortlistPage extends React.Component<RouteComponentProps<{ token: string }>> {
  selection: Candidate[] = [];
  interview: Candidate[] = [];

  state = {
    Selecao: [],
    Apresentacao: [],
    originalOpportunities: {} as originalOpportunities,
    loading: false,
    steps: {},
    token: '',
    tokenStatus: '',
    tokenNotFound: false,
    opportunityData: {} as OpportunityData
  } as any;

 categorizeCandidate = (candidate: any): void => {
  const status = candidate?.status?.current;

  if (![0, 1, 2].includes(status)) {
    return;
  }

  switch (candidate.key) {
    case 2:
      this.selection = [...this.selection, candidate];
      break;

    case 3:
    case 4:
      this.interview = [...this.interview, candidate];
      break;

    default:
      break;
  }
};

  expiredToken = (): ReactElement => {
    return (
      <div className={style["notfound"]}>
        <h2>{t("Token Não Encontrado")}</h2>
        <p>{t("O link para o kanban de candidatos não foi encontrado. Por favor, entre em contato com o administrador da vaga para obter um novo link.")}</p>
      </div>
    );
  }
  
async componentDidMount(): Promise<void> {
  const { token } = this.props.match.params;
  this.setState({ loading: true });

  try {
    const tokenData: ShortlistKanbanProps =
      (await ShortlistService.getShortlistToken(token)).data;

    this.setState({
      tokenStatus: tokenData.token.status,
      opportunityData: tokenData.opportunityId,
    });

    // 🔥 percorre candidatos
    tokenData.candidates.forEach((candidate: any) => {
      this.categorizeCandidate(candidate);
    });

    // ✅ SETSTATE FORA DO LOOP (CORRETO)
    this.setState({
      steps: {
        "Seleção": this.selection,
        "Apresentação": this.interview
      },
      token,
      loading: false
    });

  } catch (error) {
    console.error('Error fetching shortlist token data:', error);
    this.setState({ tokenNotFound: true, loading: false });
  }
}

  render() {
    const { tokenStatus } = this.state;
    return (
      <div>
        <Header>
          <div className={style["logo"]}>
            <img src={EnterLogo} alt="Enter Logo" />
          </div>
          <div className={style["header_title"]}>
            <h1 className={style["title_style"]}>{t('Kanban Candidatos')}</h1>
          </div>
        </Header>
        {this.state.tokenNotFound && 
          this.expiredToken()
        }
        {tokenStatus === 'REVOKED' && (
          <div className={style["revoked"]}>
            <p>
              {t("O link foi revogado pelo administrador e não pode mais ser acessado.")}
            </p>
          </div>)}
        {tokenStatus === 'ACTIVE' && (
          <div className={style["board_container"]}>
            <Loading show={this.state.loading} />
            <Board
              opportunityData={this.state.opportunityData}
              token={this.state.token}
              initial={this.state.steps}
              withScrollableColumns
            />
          </div>
        )}
        {tokenStatus === 'BLOCKED' && (
          <div className={style["blocked"]}>
            <p>
              {t("O link foi bloqueado pelo administrador. Entre em contato com o responsável pela vaga para mais informações.")}
            </p>
          </div>
        )}
        {tokenStatus === 'EXPIRED' && (
          <div className={style["expired"]}>
            <p>
              {t("O link expirou e não pode mais ser acessado. Entre em contato com o responsável pela vaga para mais informações.")}
            </p>
          </div>
        )}
        <Footer>
          <div>
            <section className={style["section_footer"]}>
                 <div className={style["footer-elements"]}>
                  <header className="header-footer">
                    {t("Sobre nós")}
                  </header>
                  <blockquote className="blockquote">
                    <p className="mb-0">
                      {t("A Elumini é uma consultoria de TI com +20 anos de mercado, escritórios no Brasil, Portugal e EUA e olhar diferenciado para os seus colaboradores em todo o mundo.")}
                    </p>
                  </blockquote>
                </div>
                 <div className={style["footer-elements"]}>
                  <header className="header-footer">
                    Great Place to Work®
                  </header>
                  <blockquote className="blockquote">
                    <p className="mb-0">
                      {t('A Elumini é certificada Great Place to Work® e desde 2011 está na lista das “Melhores Empresas para Trabalhar em TI”.')}
                    </p>
                  </blockquote>
                </div>
                  <div className={style["footer-elements"]}>
                  <header className="header-footer">
                    {t("Desenvolvimento contínuo")}
                  </header>
                  <blockquote className="blockquote">
                    <p className="mb-0">
                      {t("Política formal de capacitação e certificações, acesso à plataforma Alura (PIPA) e HiPD — mentoria técnica para apoiar desafios do dia a dia.")}
                    </p>
                  </blockquote>
                </div>
                <div className={style["footer-elements"]}>
                  <header className="header-footer">
                    {t("Banco de Talentos")}
                  </header>
                  <blockquote className="blockquote">
                    <p className="mb-0">
                      {t("Ao cadastrar seu currículo no Enter, seu perfil passa a ficar no nosso radar para futuras oportunidades. Seus dados são tratados em conformidade com a LGPD.")}
                    </p>
                  </blockquote>
                </div>
            </section>
          </div>
          <div className="bg-footer-2 text-center p-3">Enter Elumini © {new Date().getFullYear()}</div>
        </Footer>
      </div>
    );
  }
}

const mapStateToProps = (store: {
  shortlistUpdateReducer: {
    shortlistStatusIsSelected: boolean,
    shortlistStatusIsReproved: boolean
  };
}) => ({
  shortlistStatusIsSelected: store.shortlistUpdateReducer.shortlistStatusIsSelected,
  shortlistStatusIsReproved: store.shortlistUpdateReducer.shortlistStatusIsReproved,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => bindActionCreators(
  {
    clickUpdateShortlistStatusIsReproved,
    clickUpdateShortlistStatusIsSelected,
  },
  dispatch
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LinkShortlistPage));